
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'

export function regionSettingList(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/page/list', data)
}

export function syncRegionSetting() {
    return request.post<AxiosResult>('/fbu/api/report/region/sync')
}

export function deleteRegionSetting(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/delete', data)
}

export function createRegionSetting(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/create', data)
}

export function updateRegionSetting(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/update', data)
}

export function regionList(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/list', data)
}

export function detailRegionSetting(data?: any) {
    return request.post<AxiosResult>('/fbu/api/report/region/detail', data)
}